"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.shouldShowTermSelectorForMerchSelector = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _TermSelector = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/TermSelector"));

var _ActiveHubSelectors = require("pricing-pages-unified-ui/selectors/ActiveHubSelectors");

var _MerchandiseIdsToUpgradeProducts = require("self-service-api/constants/MerchandiseIdsToUpgradeProducts");

var _Tracking = require("pricing-pages-unified-ui/constants/Tracking");

var _PromotionSelectors = require("pricing-pages-unified-ui/selectors/PromotionSelectors");

var _HubMap = _interopRequireDefault(require("self-service-api/constants/HubMap"));

var _ItemConfigsSelectors = require("pricing-pages-unified-ui/selectors/ItemConfigsSelectors");

var _ProductOwnershipSelectors = require("pricing-pages-unified-ui/selectors/ProductOwnershipSelectors");

var _CurrencySelectors = require("../../selectors/CurrencySelectors");

var _SkeletonLoadWrapper = _interopRequireDefault(require("../loading/SkeletonLoadWrapper"));

var _LoadingStateSelectors = require("../../selectors/LoadingStateSelectors");

var _ExperimentTreatmentSelectors = require("../../selectors/ExperimentTreatmentSelectors");

var Whitespace = _styledComponents.default.div.withConfig({
  displayName: "MerchCardTermSelectorContainer__Whitespace",
  componentId: "sc-11c9m8x-0"
})(["height:", "px;"], function (props) {
  return props.height;
});

var MerchCardTermSelectorContainer = function MerchCardTermSelectorContainer(_ref) {
  var activeTerm = _ref.activeTerm,
      merchandiseId = _ref.merchandiseId,
      onChange = _ref.onChange,
      hasMultipleTerms = _ref.hasMultipleTerms,
      hasTermSelectorOnPage = _ref.hasTermSelectorOnPage,
      annualDiscount = _ref.annualDiscount,
      activeCurrencyCode = _ref.activeCurrencyCode,
      hasPricingAndPurchasingSucceeded = _ref.hasPricingAndPurchasingSucceeded;
  var mon386Variant = (0, _reactRedux.useSelector)(_ExperimentTreatmentSelectors.mon386VariantSelector);

  if (!hasTermSelectorOnPage) {
    return _react.default.createElement(Whitespace, {
      height: 20
    });
  }

  if (!hasMultipleTerms) {
    return _react.default.createElement(Whitespace, {
      height: 38
    });
  }

  var upgradeProduct = _MerchandiseIdsToUpgradeProducts.MerchandiseIdsToUpgradeProducts[merchandiseId];
  return _react.default.createElement("div", {
    className: mon386Variant !== 'control' ? 'm-top-3 text-center' : 'm-top-3'
  }, _react.default.createElement("b", null, _react.default.createElement(_SkeletonLoadWrapper.default, {
    isLoading: !hasPricingAndPurchasingSucceeded,
    heights: [26],
    widths: [216]
  }, _react.default.createElement(_TermSelector.default, {
    activeTerm: activeTerm,
    onChange: onChange,
    trackingSource: _Tracking.MERCH_CARD + "-" + upgradeProduct,
    annualDiscountPercent: annualDiscount,
    activeCurrencyCode: activeCurrencyCode
  }))));
};

var shouldShowTermSelectorForMerchSelector = function shouldShowTermSelectorForMerchSelector(state, merchandiseId) {
  var availableTerms = (0, _ItemConfigsSelectors.availableTermsForMerchSelector)(state, merchandiseId);
  var hasTwoTerms = availableTerms.monthly && availableTerms.annual;
  var ownsProductOrHigher = (0, _ProductOwnershipSelectors.ownsProductOrHigherSelector)(state, merchandiseId);
  return hasTwoTerms && !ownsProductOrHigher;
}; // Used to determine if we should render smaller padding
// between title and ctas in merch cards


exports.shouldShowTermSelectorForMerchSelector = shouldShowTermSelectorForMerchSelector;

var hasTermSelectorOnPage = function hasTermSelectorOnPage(state, hub) {
  return _HubMap.default[hub].highlightedPaidMerch.some(function (merchandiseId) {
    return shouldShowTermSelectorForMerchSelector(state, merchandiseId);
  });
};

var mapStateToProps = function mapStateToProps(state, _ref2) {
  var merchandiseId = _ref2.merchandiseId;
  var hub = (0, _ActiveHubSelectors.activeHubSelector)(state);
  return {
    hasMultipleTerms: shouldShowTermSelectorForMerchSelector(state, merchandiseId),
    hasTermSelectorOnPage: hasTermSelectorOnPage(state, hub),
    hasPricingAndPurchasingSucceeded: (0, _LoadingStateSelectors.hasPricingAndPurchasingSucceededSelector)(state),
    annualDiscount: (0, _PromotionSelectors.annualDiscountSelector)(state, merchandiseId),
    activeCurrencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(MerchCardTermSelectorContainer);

exports.default = _default;